import { GlobalPositionStrategy, OverlayRef } from '@angular/cdk/overlay';

export class NotificationsPositionStrategy extends GlobalPositionStrategy {
  private overlayRef: OverlayRef;

  public attach(overlayRef: OverlayRef) {
    this.overlayRef = overlayRef;
    super.attach(overlayRef);
  }

  public apply(): void {
    Promise.resolve().then(() => {
      const { overlayElement } = this.overlayRef;
      overlayElement.style.alignItems = this['_alignItems'];
      overlayElement.style.display = 'flex';
      overlayElement.style.width = '100%';
      overlayElement.style.height = '100%';
      super.apply();
    });
  }
}
